<script lang="ts">
  import { portal } from "svelte-portal/src/Portal.svelte";
  import { fade } from "svelte/transition";
  import { modals } from "$lib/stores/modal";
  import PrivacyPolicyPage from "$lib/layouts/PrivacyPolicyPage/PrivacyPolicyPage.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import Modal from "$lib/components/Modal/Modal.svelte";

  let modal: Modal;
  export let isOpen = false;

  let viewportWidth;
  let isMobile = false;
  let lgWidth = 1280;

  let onPrivacyPage = false;

  $: viewportWidth >= lgWidth ? (isMobile = false) : (isMobile = true);
</script>

<style lang="scss">
  .full-screen {
    position: absolute;
    top: 0;
    left: 0;
    background-color: $surface;
    width: 100vw;
    z-index: 1004;
  }
  .privacy-modal {
    display: grid;
    row-gap: 24px;
    margin: 0 16px;
    padding: 32px 24px 48px;
    z-index: 10;
    height: 100%;

    &--close {
      background-color: $surface;
      border: none;
      padding: 0;
      margin: 0;

      position: sticky;
      display: flex;
      right: 32px;
      top: 32px;
      z-index: 100;
    }

    &--close-mobile {
      background-color: $surface;
      border: none;
      padding: 0;
      margin: 0;

      position: fixed;
      top: 32px;
      right: 32px;
      @include breakpoint(md) {
        right: 44px;
        top: 24px;
      }
    }
  }
  .cover {
    background-color: rgba(0, 0, 0, 0.1);
    position: fixed;
    z-index: 0;
    height: 100vh;
    width: 100vw;
    top: 0px;
  }

  :global(.modal.privacy-modal-wrapper.desktop div[role="dialog"]) {
    display: flex;
    max-width: 80%;
    overflow-y: scroll;
    height: 70vh;
    background-color: $surface;

    position: absolute;
  }

  :global(.modal.privacy-modal-wrapper.mobile div[role="dialog"]) {
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    width: 100%;
    overflow-y: scroll;
    height: 100vh;
    background-color: $surface;

    position: absolute;
  }
</style>

<svelte:window bind:innerWidth={viewportWidth} />

<Modal
  bind:this={modal}
  backgroundColor="var(--on-surface-30)"
  isOpen={isOpen && !onPrivacyPage}
  usePortal
  className={`privacy-modal-wrapper ${isMobile ? "mobile" : "desktop"}`}
>
  <div class={isMobile ? "full-screen" : "privacy-modal"}>
    <PrivacyPolicyPage modal />
    {#if isMobile}
      <button
        type="button"
        class="privacy-modal--close-mobile"
        on:click={modal.close}
      >
        <Icon icon="close" color="var(--on-surface)" />
      </button>
    {/if}
  </div>
  {#if !isMobile}
    <div use:portal transition:fade={{ duration: 750 }} class="cover" />
    <button type="button" class="privacy-modal--close" on:click={modal.close}>
      <Icon icon="close" color="var(--on-surface)" />
    </button>
  {/if}
</Modal>
